import useMainClass from 'hooks/use-main-cass'
import textServices from 'services/text-services'
import Button from 'components/button'

const defaultView = (rallyType: string) => {
  return (
    <div className="w-full flex flex-col gap-6 px-7 flex-1">
      <div className="flex-1 w-full flex flex-col items-center justify-center gap-6 text-center h-screen">
        <h1 className='album__qr__title'>
          {textServices?.findByText(`social/${rallyType}/qr/register/title`, {
            es: (
              <>
                PARTICIPA Y GANA
              </>
            ),
            en: (
              <>
                PARTICIPATE
                <br />AND WIN
              </>
            )
          })}
        </h1>
        <img src={`${AZURE_BASE_URL}/album-qr-default.webp`} alt={`Imagen de Rally ${rallyType}`} className='album__qr__img' />
        <p className="flex flex-col items-center justify-center gap-5 album__qr__description">
          {textServices?.findByText(`social/${rallyType}/qr/register/description`, {
            es: (
              <>
                <span>¿Ya tienes tu ID?</span>
                Si no lo tienes córrele a registrarte <br /> para poder participar.
              </>
            ),
            en: (
              <>
                <span>Do you already have your ID?</span>
                If you don&apos;t have it, hurry up and register <br /> to be able to participate.
              </>
            )
          })}
        </p>
      </div>
    </div>
  )
}

export default function albumPopup({ handleClick, rallyType }: { handleClick: () => void; rallyType: string }) {
  useMainClass('album__pop-up')
  return (
    <div className='flex flex-col justify-evenly'>
      {textServices?.findByText(`social/${rallyType}/qr/register/html`, defaultView(rallyType))}
      <div className="w-full px-7 album__qr__btn">
        <Button onClick={handleClick}>
          {textServices?.findByText('social/qr/register/button', { es: 'COMENCEMOS', en: 'START' })}
        </Button>
      </div>
    </div>
  )
}
